import React, { useRef } from 'react';
import { DebounceInput } from 'react-debounce-input';
import PropTypes from 'prop-types';

const SearchForm = ({
  placeholder,
  handleTextChange,
  query,
  handleClear
}) => {
  const component = useRef(null);

  return (
    <div
      className="search-results__input"
      aria-owns="options-list"
      ref={component}
    >
      <div className="search-results__form">
        <DebounceInput
          type="text"
          value={query}
          debounceTimeout={500}
          onChange={handleTextChange}
          className="search-results__input"
          placeholder={placeholder}
        />
        {!!query && (
          <button
            type="button"
            className="search-results__clear"
            onClick={handleClear}
          >
            <svg className="search-results__close-icon">
              <use xlinkHref="#close" />
            </svg>
          </button>
        )}
        <span
          className={
            !!query && query.length >= 3
              ? 'search-results__submit'
              : 'search-results__submit search-results__submit--disabled'
          }
        >
          <svg viewBox="0 0 11 11" className="search-results__form-icon">
            <use xlinkHref="#search" />
          </svg>
        </span>
      </div>
    </div>
  );
};

SearchForm.propTypes = {
  initialQuery: PropTypes.string,
  placeholder: PropTypes.string.isRequired,
  clearLabel: PropTypes.string,
  searchLabel: PropTypes.string,
  onClear: PropTypes.func,
  onSearch: PropTypes.func
};

export default SearchForm;
